/* eslint-disable react/destructuring-assignment */
import React, { useRef } from 'react';
import {
    Box,
    Typography,
    Divider,
    Grid,
    Button,
    Paper,
    useTheme,
    DialogTitle,
    Dialog,
    DialogContent,
    DialogActions,
    Stack,
    TextField
} from '@mui/material';
import { Print } from '@mui/icons-material';
import { useReactToPrint } from 'react-to-print';
import ReportHeader from 'reusable-components/ReportHeader';
import axios from 'axios';
import { dispatch } from 'store';
import { openSnackbar } from 'store/slices/snackbar';
import { useFormik } from 'formik';
import moment from 'moment';

const InfoText = ({ label, value }) => (
    <Typography sx={{ mb: 0.6, lineHeight: 1.6 }}>
        <strong style={{ color: '#333' }}>{label}:</strong> <span style={{ color: '#000' }}>{value}</span>
    </Typography>
);

const Section = ({ title, student, color, joinDate }) => (
    <Box px={4} py={3}>
        <Typography
            variant="subtitle1"
            fontWeight="bold"
            textAlign="center"
            mb={3}
            sx={{
                textTransform: 'uppercase',
                fontFamily: "'Georgia', serif",
                fontSize: 16,
                letterSpacing: 0.5,
                color
            }}
        >
            {title}
        </Typography>

        <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
                <InfoText label="Name" value={student?.studentMini?.studentName} />
                <InfoText label="Roll No" value={student?.rollNo} />
                <InfoText label="Course" value={student?.studentMini?.courseName} />
                <InfoText label="Phone" value={student?.studentMini?.phone} />
            </Grid>
            <Grid item xs={12} sm={6}>
                <InfoText label="Hostel" value={student?.room?.building?.name} />
                <InfoText label="Date of Allocation" value={moment(student?.allocatedDate).format('DD-MM-YYYY')} />
                <InfoText label="Updated Join Date" value={moment(joinDate).format('DD-MM-YYYY')} />
                <InfoText label="Room No." value={student?.room?.name} />
            </Grid>
        </Grid>

        <Box display="flex" justifyContent="space-between" alignItems="center" mt={5}>
            <Typography>Date: ________________</Typography>
            <Typography>Authorized Signatory*</Typography>
        </Box>
    </Box>
);

const JoinDateUpdateReceipt = ({ student, joinDate }) => {
    const componentRef = useRef();
    const theme = useTheme();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    return (
        <>
            <Button variant="contained" startIcon={<Print />} color="secondary" onClick={handlePrint}>
                Print
            </Button>
            <Paper
                ref={componentRef}
                elevation={4}
                sx={{
                    width: '95%',
                    maxWidth: 850,
                    margin: 'auto',
                    mt: 3,
                    border: `2px solid ${theme.palette.secondary.main}`,
                    backgroundColor: '#fffef8',
                    fontFamily: "'Georgia', serif"
                }}
            >
                <Box textAlign="center" py={2} sx={{ borderBottom: `1px solid ${theme.palette.secondary.light}` }}>
                    <Box display="flex" alignItems="center" justifyContent="center">
                        <ReportHeader />
                    </Box>
                    <Box borderBottom="2px solid #d0464d" mt={1} />
                    <Typography variant="h5" color="textSecondary" mt={1} fontSize={15} fontWeight={600}>
                        Updated Hostel Admission Record
                    </Typography>
                </Box>
                <Section title="Warden Copy" student={student} color={theme.palette.secondary.main} joinDate={joinDate} />
                <Divider sx={{ borderBottom: '2px dashed #999', my: 2 }} />
                <Box textAlign="center" py={2} sx={{ borderBottom: `1px solid ${theme.palette.secondary.light}` }}>
                    <Box display="flex" alignItems="center" justifyContent="center">
                        <ReportHeader />
                    </Box>
                    <Box borderBottom="2px solid #d0464d" mt={1} />
                    <Typography variant="h5" color="textSecondary" mt={1} fontSize={15} fontWeight={600}>
                        Updated Hostel Admission Record
                    </Typography>
                </Box>
                <Section title="Student Copy" student={student} color={theme.palette.secondary.main} joinDate={joinDate} />
            </Paper>
        </>
    );
};
export default function UpdateJoinDateDialog(props) {
    const selectedStudent = props?.data?.row;
    const [showReceipt, setShowReceipt] = React.useState(false);
    const [updatedJoinDate, setUpdatedJoinDate] = React.useState('');

    const formik = useFormik({
        initialValues: {
            joinDate: props.data.joinDate
        },
        onSubmit: (value) => {
            const data = {};
            axios
                .put(`/v1/hostel/students/join-date/mark?studentId=${props.data.studentId}&joinDate=${value.joinDate}`, data, {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                        'Content-Type': 'application/json'
                    }
                })
                .then((result) => {
                    dispatch(
                        openSnackbar({
                            open: true,
                            message: 'Join Date updated successfully',
                            variant: 'alert',
                            alert: {
                                color: 'success'
                            },
                            close: false
                        })
                    );
                    setUpdatedJoinDate(value.joinDate);
                    setShowReceipt(true);
                    props.fetchStudentsDetails(props.fetchData);
                })
                .catch((error) => {
                    console.log(error, 'error');
                });
        }
    });

    return (
        <>
            <Dialog open={props.open} onClose={props.handleCloseD} aria-labelledby="form-dialog-title">
                {props.open && (
                    <>
                        <DialogTitle id="form-dialog-title" minWidth={600}>
                            Update Join Date
                        </DialogTitle>
                        <DialogContent>
                            <form onSubmit={formik.handleSubmit}>
                                <Stack spacing={4}>
                                    <Grid item xs={12} md={4} sx={{ mt: 3 }}>
                                        <TextField
                                            type="date"
                                            id="joinDate"
                                            name="joinDate"
                                            value={formik.values.joinDate}
                                            label="Join Date*"
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                            }}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            fullWidth
                                        />
                                    </Grid>
                                </Stack>

                                <Grid item sx={{ display: 'flex', justifyContent: 'end', mt: 3 }}>
                                    <Button variant="contained" onClick={props.handleCloseD} color="error">
                                        Cancel
                                    </Button>
                                    <Button type="submit" variant="contained" sx={{ ml: 4 }}>
                                        Update
                                    </Button>
                                </Grid>
                            </form>
                        </DialogContent>
                        <DialogActions />
                    </>
                )}
            </Dialog>

            {showReceipt && (
                <Dialog open={showReceipt} onClose={() => setShowReceipt(false)} maxWidth="md" fullWidth>
                    <DialogTitle>Join Date Update Receipt</DialogTitle>
                    <DialogContent>
                        <JoinDateUpdateReceipt student={selectedStudent} joinDate={updatedJoinDate} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowReceipt(false)} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}
// /* eslint-disable react/prop-types */
// /* eslint-disable react/destructuring-assignment */
// import React from 'react';
// // material-ui
// import { useTheme } from '@mui/material/styles';
// import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Stack, TextField } from '@mui/material';
// import axios from 'axios';
// import { openSnackbar } from 'store/slices/snackbar';
// import { useFormik } from 'formik';
// import { dispatch } from 'store';

// // ===============================|| UI DIALOG - FORMS ||=============================== //

// export default function UpdateJoinDateDialog(props) {
//     const selectedStudent = props?.data?.row;
//     console.log(selectedStudent, 'selectedStudentselectedStudent');
//     const formik = useFormik({
//         initialValues: {
//             joinDate: props.data.joinDate
//         },
//         onSubmit: (value) => {
//             const data = {};
//             axios
//                 .put(`/v1/hostel/students/join-date/mark?studentId=${props.data.studentId}&joinDate=${value.joinDate}`, data, {
//                     headers: {
//                         Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
//                         'Content-Type': 'application/json'
//                     }
//                 })
//                 .then((result) => {
//                     dispatch(
//                         openSnackbar({
//                             open: true,
//                             message: 'Join Date updated successfully',
//                             variant: 'alert',
//                             alert: {
//                                 color: 'success'
//                             },
//                             close: false
//                         })
//                     );
//                     props.handleCloseD();
//                     props.fetchStudentsDetails(props.fetchData);
//                 })
//                 .catch((error) => {
//                     console.log(error, 'error');
//                 });
//         }
//     });

//     return (
//         <Dialog open={props.open} onClose={props.handleCloseD} aria-labelledby="form-dialog-title">
//             {props.open && (
//                 <>
//                     <DialogTitle id="form-dialog-title" minWidth={600}>
//                         Update Join Date
//                     </DialogTitle>
//                     <DialogContent>
//                         <form onSubmit={formik.handleSubmit}>
//                             <Stack spacing={4}>
//                                 <Grid item xs={12} md={4} sx={{ mt: 3 }}>
//                                     <TextField
//                                         type="date"
//                                         id="joinDate"
//                                         name="joinDate"
//                                         value={formik.values.joinDate}
//                                         label="Join Date*"
//                                         onChange={(e) => {
//                                             formik.handleChange(e);
//                                         }}
//                                         InputLabelProps={{
//                                             shrink: true
//                                         }}
//                                         fullWidth
//                                     />
//                                 </Grid>
//                             </Stack>

//                             <Grid item sx={{ display: 'flex', justifyContent: 'end', mt: 3 }}>
//                                 <Button variant="contained" onClick={props.handleCloseD} color="error">
//                                     Cancel
//                                 </Button>
//                                 <Button type="submit" variant="contained" sx={{ ml: 4 }}>
//                                     Update
//                                 </Button>
//                             </Grid>
//                         </form>
//                     </DialogContent>
//                     <DialogActions />
//                 </>
//             )}
//         </Dialog>
//     );
// }
